import React from 'react';
import TextareaAutosize from 'react-textarea-autosize';

import Box from '../Box/Box';
import parentName from './name';
import TTextField from './@types/TextField';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';

type TTextFieldInputMultiLine = TTextField & {
  defaultValue?: string;
  minRows: number;
  maxRows: number;
  helperTextId?: string;
  errorTextId?: string;
  charsExceededId?: string;
};

// eslint-disable-next-line react/display-name
const TextFieldInputMultiLine = React.forwardRef(
  (
    {
      id,
      isRequired,
      onChange,
      defaultValue,
      minRows,
      maxRows,
      name,
      ariaLabel,
      ariaLabelledBy,
      helperTextId,
      errorTextId,
      charsExceededId,
      ...rest
    }: TTextFieldInputMultiLine,
    ref,
  ) => {
    const conditionalProps = filterConditionalKeyValues({
      'aria-label': ariaLabel,
      'aria-labelledby': ariaLabelledBy,
    });

    // Build aria-describedby to include helper text, error text, and chars exceeded
    const describedByIds = [helperTextId, errorTextId, charsExceededId].filter(Boolean).join(' ');

    return (
      <Box
        {...rest}
        {...conditionalProps}
        parent={parentName}
        name="input"
        minRows={minRows}
        maxRows={maxRows}
        modifiers={['multiline']}
        onChange={onChange}
        as={TextareaAutosize as any}
        id={id}
        htmlNameAttr={name || id}
        ref={ref}
        required={isRequired}
        defaultValue={defaultValue}
        aria-describedby={describedByIds || undefined}
        aria-invalid={errorTextId || charsExceededId ? 'true' : 'false'}
      />
    );
  },
);

export default TextFieldInputMultiLine;
